var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUthermMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22",
    "data-name": "Group 22",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.334,
    height: 36.895,
    viewBox: "0 0 73.334 36.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M.964-2.182c.3,0,.31-.424.556,1.628s.427,6.579.427,6.579V21.959A1.136,1.136,0,0,1,.774,23.033c-.428,0-.774-.626-.774-1.4V6.024S.1,1.5.338-.554.668-2.182.964-2.182Z",
    transform: "translate(4.531 2.218)",
    fill: "#868686"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect43",
    width: 73.334,
    height: 26.988,
    rx: 4.806,
    transform: "translate(0 9.907)",
    fill: "#efefef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 68.463,
    height: 22.355,
    rx: 4,
    transform: "translate(2.668 12.211)",
    fill: "#fafafa"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471",
    width: 5.184,
    height: 5.437,
    rx: 1.44,
    transform: "translate(12.872 14.006)",
    fill: "#9f9f9f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2",
    width: 0.535,
    height: 3.185,
    rx: 0.267,
    transform: "translate(6.478 15.086)",
    fill: "#9f9f9f"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4",
    width: 0.535,
    height: 3.185,
    rx: 0.267,
    transform: "translate(7.506 15.086)",
    fill: "#9f9f9f"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4-5",
    width: 0.535,
    height: 3.185,
    rx: 0.267,
    transform: "translate(8.515 15.177)",
    fill: "#9f9f9f"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-2-4-5-7",
    width: 0.535,
    height: 3.185,
    rx: 0.267,
    transform: "translate(9.479 15.177)",
    fill: "#9f9f9f"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-0",
    width: 5.184,
    height: 5.437,
    rx: 1.44,
    transform: "translate(55.744 14.299)",
    fill: "#9f9f9f"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "rect471-8",
    width: 25.96,
    height: 5.437,
    rx: 2.718,
    transform: "translate(23.705 14.299)",
    fill: "#9f9f9f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUthermMini);
export default __webpack_public_path__ + "static/media/utherm_mini.871681097c77bf207c3be60499bbfae4.svg";
export { ForwardRef as ReactComponent };